// Shared server-client clock offset (ms). Updated by useGameSocket on every state message.
// StageTimer reads this at each tick to avoid drift on students' phones whose clocks are off.
let offsetMs = 0;

export function setServerOffsetFromISO(iso) {
  if (!iso) return;
  try {
    offsetMs = new Date(iso).getTime() - Date.now();
  } catch {}
}

export function serverNow() {
  return Date.now() + offsetMs;
}
